import { type Dispatch, type FC, type SetStateAction } from "react";
import { ContestGuideline } from "@clientFrontend/features/campaign/components/UserPhotoContest/uiParts/ContestGuideline";
import { ContestEntryCassette } from "@clientFrontend/features/campaign/components/UserPhotoContest/uiParts/ContestEntryCassette";
import {
  type PhotoContestEntry,
  type PhotoContestGuidelines,
  type Division,
  type RemainingVotableCountsByDivision,
} from "@clientFrontend/features/campaign/components/UserPhotoContest/type";
import * as styles from "./styles.css";

type Props = {
  contestEntries: PhotoContestEntry[];
  contestGuidelines: PhotoContestGuidelines;
  votePath: string;
  commentPath: string;
  isClientScoutable: boolean;
  isVotingPeriodOver: boolean;
  clienRemainingVotableCounts: RemainingVotableCountsByDivision;
  setClienRemainingVotableCounts: Dispatch<SetStateAction<RemainingVotableCountsByDivision>>;
  activeTab: Division;
  setActiveTab: Dispatch<SetStateAction<Division>>;
};

export const Presentation: FC<Props> = ({
  contestEntries,
  contestGuidelines,
  votePath,
  commentPath,
  isClientScoutable,
  isVotingPeriodOver,
  clienRemainingVotableCounts,
  setClienRemainingVotableCounts,
  activeTab,
  setActiveTab,
}) => {
  const modelEntries = contestEntries.filter((entry) => entry.division === "model");
  const wigEntries = contestEntries.filter((entry) => entry.division === "wig");

  return (
    <div className={styles.wrapper}>
      <ContestGuideline
        contestGuidelines={contestGuidelines}
        isVotingPeriodOver={isVotingPeriodOver}
      />
      <div className={styles.contestCassetteContainer}>
        <div className={styles.contestCassetteWrapper}>
          <div className={styles.totalEntryCountWrapper}>
            <div className={styles.totalEntryCountText}>
              エントリー作品
              <span className={styles.totalEntryCount}>(全{contestEntries.length}作品)</span>
            </div>
          </div>
          <div className={styles.tabContainer}>
            <button
              type="button"
              className={`${styles.tabButton} ${activeTab === "model" ? styles.tabButtonActive : styles.tabButtonInactive}`}
              onClick={() => setActiveTab("model")}
            >
              モデル部門({modelEntries.length}作品)
            </button>
            <button
              type="button"
              className={`${styles.tabButton} ${activeTab === "wig" ? styles.tabButtonActive : styles.tabButtonInactive}`}
              onClick={() => setActiveTab("wig")}
            >
              ウィッグ部門({wigEntries.length}作品)
            </button>
          </div>

          {/* モデル部門コンテンツ */}
          <div
            className={activeTab === "model" ? styles.tabContentVisible : styles.tabContentHidden}
          >
            <div className={styles.remainingVoteCountText}>
              のこり{" "}
              <span className={styles.remainingVoteCountNumber}>
                {clienRemainingVotableCounts.model}
              </span>
              票
            </div>
            <div className={styles.contestEntryWrapper}>
              {modelEntries.map((photoContestEntry, index) => (
                <div key={photoContestEntry.id}>
                  <ContestEntryCassette
                    entryNo={index + 1}
                    photoContestEntry={photoContestEntry}
                    isClientScoutable={isClientScoutable}
                    votePath={votePath}
                    commentPath={commentPath}
                    isClientNotVotable={clienRemainingVotableCounts.model === 0}
                    isVotingPeriodOver={isVotingPeriodOver}
                    setClienRemainingVotableCounts={setClienRemainingVotableCounts}
                  />
                </div>
              ))}
            </div>
          </div>

          {/* ウィッグ部門コンテンツ */}
          <div className={activeTab === "wig" ? styles.tabContentVisible : styles.tabContentHidden}>
            <div className={styles.remainingVoteCountText}>
              のこり{" "}
              <span className={styles.remainingVoteCountNumber}>
                {clienRemainingVotableCounts.wig}
              </span>
              票
            </div>
            <div className={styles.contestEntryWrapper}>
              {wigEntries.map((photoContestEntry, index) => (
                <div key={photoContestEntry.id}>
                  <ContestEntryCassette
                    entryNo={index + 1}
                    photoContestEntry={photoContestEntry}
                    isClientScoutable={isClientScoutable}
                    votePath={votePath}
                    commentPath={commentPath}
                    isClientNotVotable={clienRemainingVotableCounts.wig === 0}
                    isVotingPeriodOver={isVotingPeriodOver}
                    setClienRemainingVotableCounts={setClienRemainingVotableCounts}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
